import printCheckoutComponent from './print_checkout.component';

let printCheckoutModule = angular.module('printCheckout', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/checkout');

		$stateProvider
			.state('printCheckout', {
				url: '/print-checkout/{branchId}/{scannedRouteId}/{date}',
				component: 'printCheckout',
				data: {
					requireLogin: true,
					requireACL: 'check_out.all'	
				},
			});
	})

	.component('printCheckout', printCheckoutComponent)

	.name;

export default printCheckoutModule;

// ?branch&route&date



// WEBPACK FOOTER //
// ./client/app/components/checkout/print/index.js